import {
  Button,
  Classes,
  Dialog,
  FileInput,
  FormGroup,
  H5,
  InputGroup,
  NumericInput,
  Popover,
} from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { IAjuste, newIAjuste } from "../../model";
import { Pager } from "../utils/Pager";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { AppStore } from "../../stores/AppStore";
import { PautaRsStore } from "../../stores/admin/PautaRsStore";
import moment from "moment";
import { observable } from "mobx";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
import { toast } from "react-toastify";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";


@observer
export class PautaRsPage extends React.Component<{}, {}> {

  obs = observable({
    open_view_erros: false,
    ajuste: {} as {
      id: null,
      ano: null,
      ciclo: null,
    },
    loading: false,
    loading_import: false,
    open_import_pmpf: false as boolean,
    file_name: "Selecione um arquivo csv!",
    open_create: false as boolean,

    add_ajuste: null as IAjuste,

  })

  componentDidMount() {
    AppStore.setTitle("Pauta RS");

    PautaRsStore.obs.currentPage = 1

    PautaRsStore.handlePageFilter(1, PautaRsStore.obs.filter);

  }

  handlePageChange = async (page: number) => {

    PautaRsStore.obs.currentPage = page

    await PautaRsStore.handlePageFilter(PautaRsStore.obs.currentPage, PautaRsStore.obs.filter);

  };

  async handlePageFilter(filtro: string) {

    PautaRsStore.obs.currentPage = 1
    PautaRsStore.obs.filter = filtro

    await PautaRsStore.handlePageFilter(1, filtro)

  }

  validadeFormatter(d) {

    return d ? moment(d).add(3, "hour").format("DD/MM/YYYY") : null;

  }

  async openPmpfs(row) {

    PautaRsStore.obs.pmpfs = []
    PautaRsStore.obs.current_page_pmpf = 1
    PautaRsStore.obs.filter_pmpf = ""

    this.obs.ajuste = row

    this.obs.loading = true

    await PautaRsStore.handlePmpf(1, row.ano, row.ciclo, "")

    this.obs.loading = false

    this.obs.open_view_erros = true

  }

  onClose() {

    this.obs.open_view_erros = false

    this.obs.ajuste = {
      id: null,
      ano: null,
      ciclo: null
    }

    PautaRsStore.obs.pmpfs = []
    PautaRsStore.obs.current_page_pmpf = 1
    PautaRsStore.obs.filter_pmpf = ""

  }

  async handlePagePmpfs(page) {

    PautaRsStore.obs.current_page_pmpf = page

    await PautaRsStore.handlePmpf(page, this.obs.ajuste.ano, this.obs.ajuste.ciclo, PautaRsStore.obs.filter_pmpf)

  };

  async handleFilterPmpfs(filtro: string) {

    PautaRsStore.obs.current_page_pmpf = 1
    PautaRsStore.obs.filter_pmpf = filtro

    await PautaRsStore.handlePmpf(1, this.obs.ajuste.ano, this.obs.ajuste.ciclo, filtro)

  }

  handleImport(row) {

    this.obs.ajuste = row

    this.obs.open_import_pmpf = true;

  };

  handleFileInputChange = async (event) => {

    this.obs.loading_import = true;

    const file = event.target.files[0];

    this.obs.file_name = file.name

    var data = new FormData();

    data.append("file", file);
    data.append("ano", this.obs.ajuste.ano);
    data.append("ciclo", this.obs.ajuste.ciclo);
    data.append("id", this.obs.ajuste.id);

    this.obs.open_import_pmpf = false;

    let res = await PautaRsStore.handleImport(data)

    if (res) {

      PautaRsStore.obs.currentPage = 1;

      await PautaRsStore.handlePageFilter(1, "")

    }

    this.obs.file_name = "Selecione um arquivo csv!"

    this.obs.loading_import = false;

  };

  handleCreateConfig() {

    this.obs.add_ajuste = newIAjuste()

    this.obs.open_create = true

  }

  async handleSaveCreate() {

    if (!this.obs.add_ajuste.nome) {
      toast.warning('Preencha o campo Nome.', {});
      return
    }

    if (!this.obs.add_ajuste.ciclo) {
      toast.warning('Preencha o campo Ciclo.', {});
      return
    }

    if (!this.obs.add_ajuste.ano) {
      toast.warning('Preencha o campo Ano.', {});
      return
    }

    if (!this.obs.add_ajuste.valido_de) {
      toast.warning('Preencha o campo (Valido de).', {});
      return
    }

    if (!this.obs.add_ajuste.valido_ate) {
      toast.warning('Preencha o campo (Valido ate).', {});
      return
    }

    if (valido_de > valido_ate) {
      toast.warning('Campo (Valido de) não pode ser maior que (Valido até)', {});
      return;
    }

    var valido_de = moment(this.obs.add_ajuste.valido_de).format("YYYY-MM-DD")
    var valido_ate = moment(this.obs.add_ajuste.valido_ate).format("YYYY-MM-DD")

    const ajuste = {
      nome: this.obs.add_ajuste.nome,
      ciclo: this.obs.add_ajuste.ciclo,
      ano: this.obs.add_ajuste.ano,
      valido_de: valido_de,
      valido_ate: valido_ate
    }

    this.obs.open_create = false

    let resp = await PautaRsStore.doSaveCreateAjuste(ajuste);

    if (resp) {

      this.handlePageFilter("")

    }

  }

  handleValueChangeCiclo = (valueAsNumber: number, valueAsString: string) => {

    this.obs.add_ajuste.ciclo = valueAsNumber

  };

  handleValueChangeAno = (valueAsNumber: number, valueAsString: string) => {

    this.obs.add_ajuste.ano = valueAsNumber

  };

  async handleDeletePmpf(id: string) {

    let resp = await PautaRsStore.handleDeletePmpf(id)

    if (resp) {

      this.handlePageFilter("")

    }

  }

  onCloseCreate() {

    this.obs.add_ajuste = newIAjuste()

    this.obs.open_create = false

  }

  render() {

    let items = PautaRsStore.obs.pauta?.map((value) => {

      return ({
        id: value._id,
        nome: value.nome,
        ciclo: value.ciclo,
        ano: value.ano,
        valido_de: value.valido_de,
        valido_ate: value.valido_ate,
      });

    });

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm" onClick={(e) => this.openPmpfs(row)}>
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={25} />
            </MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleDeletePmpf(row.id)}>Excluir</Button>
              </div>
            </div>
          </Popover>
        </>
      );
    }

    const buttonFormatterImport = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm" onClick={(e) => this.handleImport(row)}>
            <AppIcon name="upload_file" style={{ color: "#3e6971" }} />
          </MDBBtn>
        </>
      );
    }

    return (
      <div>

        <MDBRow>
          <MDBCol md="3">
            <MDBBtn className="btnDefault noFloat" onClick={() => this.handleCreateConfig()}>
              Adicionar Configuração
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="6" className="inputFilter">
            <InputGroup
              style={{ width: 600, borderRadius: "10px" }}
              placeholder="Filtrar (GTIN, Descrição)"
              value={PautaRsStore.obs.filter}
              onChange={(e: any) => this.handlePageFilter(e.target.value)}
            />
          </MDBCol>
        </MDBRow>

        <BootstrapTable className="TableDefault" data={items}>
          <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
          <TableHeaderColumn dataField="nome" width="40%">Nome</TableHeaderColumn>
          <TableHeaderColumn dataField="ciclo" width="10%">Ciclo</TableHeaderColumn>
          <TableHeaderColumn dataField="ano" width="10%">Ano</TableHeaderColumn>
          <TableHeaderColumn dataField="valido_de" dataFormat={this.validadeFormatter} width="15%">Valido de</TableHeaderColumn>
          <TableHeaderColumn dataField="valido_ate" dataFormat={this.validadeFormatter} width="15%">Valido até</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatterImport} width="15%">Importar</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="15%">Ações</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={PautaRsStore.obs.currentPage}
            totalCount={PautaRsStore.obs.length_pauta}
            pageSize={20}
            onPageChange={page => this.handlePageChange(page)}
          />
        </div>

        <Dialog isOpen={this.obs.open_view_erros} onClose={() => this.onClose()} title="PMPF">
          <div className={Classes.DIALOG_HEADER}>

            <InputGroup
              style={{ width: 600, borderRadius: "10px" }}
              placeholder="Filtrar (GTIN, Descrição)"
              value={PautaRsStore.obs.filter_pmpf}
              onChange={(e: any) => this.handleFilterPmpfs(e.target.value)}
            />
          </div>

          <div className={Classes.DIALOG_BODY}>
            <BootstrapTable className="" data={PautaRsStore.obs.pmpfs}>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="gtin" width="20%">GTIN</TableHeaderColumn>
              <TableHeaderColumn dataField="descricao" width="40%">Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="pmpf" width="10%">PMPF</TableHeaderColumn>
              <TableHeaderColumn dataField="multiplo" width="10%">Multiplo</TableHeaderColumn>
              <TableHeaderColumn dataField="ciclo" width="10%">Ciclo</TableHeaderColumn>
              <TableHeaderColumn dataField="ano" width="10%">Ano</TableHeaderColumn>
            </BootstrapTable>

            <div style={{ marginTop: 5, float: "right" }}>
              <Pager
                currentPage={PautaRsStore.obs.current_page_pmpf}
                totalCount={PautaRsStore.obs.length_pmpf}
                pageSize={10}
                onPageChange={page => this.handlePagePmpfs(page)}
              />
            </div>

          </div>

        </Dialog>

        <Dialog isOpen={this.obs.open_import_pmpf} title={"Importar PMPF"} onClose={() => this.obs.open_import_pmpf = false}>
          <div className={Classes.DIALOG_BODY}>

            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>

              <b>Observação:</b> Ao importar o arquivo, todos os itens cadastrados no sistema serão substituídos pelos itens presentes no arquivo.<br />

            </p>

            <br />

            <FormGroup label="">
              <FileInput text={this.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_import_pmpf = false} />
            </div>
          </div>

        </Dialog>

        <Dialog isOpen={this.obs.open_create} onClose={() => this.onCloseCreate()} style={{ width: 600, height: 400 }}>
          <div className={Classes.DIALOG_BODY}>

            <h2 className="title-no-bottom">Criar Ajuste</h2>

            <MDBRow md="12">
              <MDBCol>
                <FormGroup label="Nome">
                  <InputGroup onChange={(e) => this.obs.add_ajuste.nome = e.target.value} />
                </FormGroup>
              </MDBCol>
            </MDBRow>

            <MDBRow md="12">
              <MDBCol>
                <FormGroup label="Ciclo">
                  <NumericInput className="input-numeric" onValueChange={this.handleValueChangeCiclo} buttonPosition="none" placeholder="Exemplo: 1" />
                </FormGroup>
              </MDBCol>

              <MDBCol>
                <FormGroup label="Ano">
                  <NumericInput className="input-numeric" onValueChange={this.handleValueChangeAno} buttonPosition="none" placeholder="Exemplo: 2025" />
                </FormGroup>
              </MDBCol>
            </MDBRow>

            <MDBRow md="12">
              <MDBCol>
                <FormGroup label="Valido de">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    onChange={(e) => this.obs.add_ajuste.valido_de = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>
              </MDBCol>

              <MDBCol>
                <FormGroup label="Valido até">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    onChange={(e) => this.obs.add_ajuste.valido_ate = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>
              </MDBCol>
            </MDBRow>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.onCloseCreate()} />
              <Button text="Criar" intent="primary" onClick={() => this.handleSaveCreate()} />
            </div>
          </div>
        </Dialog>

        <LoadingModal open={this.obs.loading_import} onClose={() => this.obs.loading_import = false} title={"Importando"} />
        <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Carregando"} />

      </div>
    );
  }
}

export default PautaRsPage;
